export const dateType = [
    "PODate",
    "duedate",
    "DueDate",
    "SupplierDueDate",
    "CheckedDate",
    "LRDate",
    "MathadiDate",
    "ModifiedDate",
    "QCDateTime",
    "ReceiptDate",
    "SupplierInvoiceDate",
    "QCStatusDate",
    "DateOfBirth",
    "NewDueDate",
    "CargoReadyDate",
    "CargoDelayedDate",
    "CreatedDate"


]